export default __webpack_public_path__ + "4648c5f539cd21108efdeffa5b9522e3.png";